import { useToast, ToastType } from '@/contexts/ToastContext';

const toastStyles: Record<ToastType, string> = {
  success: 'bg-success/10 border-success text-success',
  error: 'bg-error/10 border-error text-error',
  warning: 'bg-warning/10 border-warning text-warning',
  info: 'bg-info/10 border-info text-info',
};

export function ToastContainer() {
  const { toasts, removeToast } = useToast();

  return (
    <div className="fixed bottom-4 right-4 z-toast space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`border rounded-lg p-4 max-w-sm animate-in fade-in slide-in-from-bottom-2 ${
            toastStyles[toast.type]
          }`}
        >
          <div className="flex items-start justify-between gap-3">
            <p className="text-sm font-medium">{typeof toast.message === 'string' ? toast.message : String(toast.message)}</p>
            <button
              onClick={() => removeToast(toast.id)}
              className="text-lg leading-none opacity-75 hover:opacity-100 transition-opacity"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
